export default Object.freeze({
  PERMISSION_GROUP_NAME: '권한그룹명',
});
